import { render } from "./staffManage.vue?vue&type=template&id=655d47f8&scoped=true&ts=true"
import script from "./staffManage.vue?vue&type=script&lang=ts"
export * from "./staffManage.vue?vue&type=script&lang=ts"

import "./staffManage.vue?vue&type=style&index=0&id=655d47f8&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655d47f8"]])

export default __exports__